const huebSeoProductDetail = {
    state() {
        return {
            richSnippets: {},
            parentRichSnippets: {},
            apiContext: {},
            loading: {
                states: false,
                richSnippets: false,
            },
            localMode: false
        };
    },

    getters: {
        isLoading: (state) => {
            return Object.values(state.loading).some((loadState) => loadState);
        },
    },

    actions: {

        setRichSnippets(state, value) {
            state.richSnippets = value;
        },

        setParentRichSnippets(state, value) {
            state.parentRichSnippets = value;
        },

        // setApiContext(state, apiContext) {
        //     state.apiContext = apiContext;
        // },

        // setLocalMode(state, value) {
        //     state.localMode = value;
        // },

        setLoading(value: [keyof typeof this.loading, boolean]) {
            const name = value[0];
            const data = value[1];

            // check for use from .js files
            if (typeof data !== 'boolean') {
                return;
            }
            this.loading[name] = data;
        },
    }
}

export default huebSeoProductDetail;

